import React from 'react';
import { Grid } from '@mui/material';
import PageHeader from '../../../components/page-header';
import { GridPanel } from '../../../components/list-grid-panel';
import AmendmentDataTable from './components/amendment-data-table';
import { useAmendmentListController } from './context/amendment-list-controller';
import { useAmendmentListState } from './context/amendment-list-context';

export function AmendmentListComponent() {
    const ctrl = useAmendmentListController();
    const { parameters, contractId, processNumber } = useAmendmentListState();
    const contractLabel = `Contrato ${processNumber || contractId}`;

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Aditivos"
                    subtitle={`Termos aditivos, apostilamentos e rescisões do ${contractLabel}`}
                    breadcrumbs={[
                        { label: 'Contratos', href: '/contratos' },
                        { label: `Aditivos do ${contractLabel}` },
                    ]}
                />
            </Grid>

            <Grid item xs={12}>
                <GridPanel addLabel="Novo aditivo" onAdd={ctrl.navigateToCreate}>
                    <AmendmentDataTable parameters={parameters} onEdit={ctrl.navigateToEdit} />
                </GridPanel>
            </Grid>
        </React.Fragment>
    );
}
